import {ChangeDetectorRef, Directive, effect, inject, input, TemplateRef, ViewContainerRef} from '@angular/core';
import { AuthService } from '../services/auth.service';
import {UserRole} from '../../../models/generated-models';

const ALL_ROLES = 'ALL';
type RoleRequirement = UserRole | typeof ALL_ROLES;

@Directive({
  standalone: true,
  selector: '[hasAnyRole]'
})
export class HasAnyRoleDirective {
  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<any>);
  private authService = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  private alreadyAddView = false;
  hasAnyRole = input.required<RoleRequirement[]>();
  hasAnyRoleExcept = input<UserRole[]>();

  constructor() {
    effect(() => {
      const checkRoles = this.hasAnyRole();
      if (!checkRoles?.length) {
        if (!this.alreadyAddView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.alreadyAddView = true;
          this.cdr.markForCheck();
        }
        return;
      }
      // Token roles + profile authorities: delegated act-as roles such as
      // FARMER_AGENT are derived server-side and never land in the token.
      const roles = this.authService.effectiveRoles();
      const exceptRoles = this.hasAnyRoleExcept();
      const acceptsEveryRole = checkRoles.includes(ALL_ROLES);
      const hasExcludedRole = exceptRoles?.some(role => roles.includes(role));
      const hasRequiredRole = checkRoles.some(role => roles.includes(role));
      const shouldRender = acceptsEveryRole
        ? roles.length > 0 && !hasExcludedRole
        : hasRequiredRole && !hasExcludedRole;

      if (shouldRender) {
        if (!this.alreadyAddView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.alreadyAddView = true;
          this.cdr.markForCheck();
        }
      } else {
        this.viewContainer.clear();
        this.alreadyAddView = false;
        this.cdr.markForCheck();
      }
    });
  }
}
